import React, {createContext, useCallback, useContext, useState} from 'react';

const UserProfileContext = createContext({errors: {}, updateErrorState: (k, v) => {}});

function useUserProfileContext() {
  return useContext(UserProfileContext);
}

function UserProfileContextProvider({children}) {
  const [errors, setErrors] = useState({
    userForm: false,
    recordingForm: false,
    integrationForm: false,
  });

  // Wrap in useCallback so that this can be used in a useEffect().
  // Specifically, when a sub-form is notified that the user object
  // has changed, it should call this to update its error state.
  const updateErrorState = useCallback((formName, isError) => {
    setErrors(prevErrors => ({...prevErrors, [formName]: isError}));
  }, []);

  return (
    <UserProfileContext.Provider value={{errors, updateErrorState}}>
      {children}
    </UserProfileContext.Provider>
  );
}

export {UserProfileContextProvider, useUserProfileContext};
